
    <template>
      <section class="content example-md-doc">
        <anchor is-edit label="footer 行事件自定义" fileName="on-footer-row.md" />
        <demo-block>
        
        <template slot="source"><element-demo0 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;template&gt;
    &lt;div&gt;
        打开F12 查看 console 信息
        &lt;ve-table
            border-y
            fixed-header
            :max-height=&quot;300&quot;
            :columns=&quot;columns&quot;
            :table-data=&quot;tableData&quot;
            :footer-data=&quot;footerData&quot;
            rowKeyFieldName=&quot;rowKey&quot;
            :event-custom-option=&quot;eventCustomOption&quot;
        /&gt;
    &lt;/div&gt;
&lt;/template&gt;

&lt;script&gt;
    export default {
        data() {
            return {
                eventCustomOption: {
                    footerRowEvents: ({ row, rowIndex }) =&gt; {
                        return {
                            click: (event) =&gt; {
                                console.log(&quot;click::&quot;, row, rowIndex, event);
                            },
                            dblclick: (event) =&gt; {
                                console.log(&quot;dblclick::&quot;, row, rowIndex, event);
                            },
                            contextmenu: (event) =&gt; {
                                console.log(&quot;contextmenu::&quot;, row, rowIndex, event);
                            },
                            mouseenter: (event) =&gt; {
                                console.log(&quot;mouseenter::&quot;, row, rowIndex, event);
                            },
                            mouseleave: (event) =&gt; {
                                console.log(&quot;mouseleave::&quot;, row, rowIndex, event);
                            },
                        };
                    },
                },
                columns: [
                    {
                        field: &quot;&quot;,
                        key: &quot;a&quot;,
                        title: &quot;&quot;,
                        width: 50,
                        align: &quot;center&quot;,
                        renderBodyCell: ({ row, column, rowIndex }, h) =&gt; {
                            return ++rowIndex;
                        },
                    },
                    {
                        field: &quot;name&quot;,
                        key: &quot;b&quot;,
                        title: &quot;Name&quot;,
                        width: 200,
                        align: &quot;left&quot;,
                    },
                    {
                        field: &quot;hobby&quot;,
                        key: &quot;c&quot;,
                        title: &quot;Hobby&quot;,
                        width: 300,
                        align: &quot;left&quot;,
                    },
                    {
                        field: &quot;address&quot;,
                        key: &quot;d&quot;,
                        title: &quot;Address&quot;,
                        width: &quot;&quot;,
                        align: &quot;left&quot;,
                    },
                ],
                tableData: [],
            };
        },
        methods: {
            initTableData() {
                let data = [];
                for (let i = 0; i &lt; 15; i++) {
                    data.push({
                        rowKey: i,
                        name: i,
                        date: i,
                        hobby: i,
                        address: i,
                    });
                }
                this.tableData = data;
            },

            initFooterData() {
                this.footerData = [
                    {
                        rowKey: 0,
                        name: &quot;平均值&quot;,
                        date: 213,
                        hobby: 355,
                        address: 189,
                    },
                    {
                        rowKey: 1,
                        name: &quot;汇总值&quot;,
                        date: 1780,
                        hobby: 890,
                        address: 2988,
                    },
                ];
            },
        },
        created() {
            this.initTableData();
            this.initFooterData();
        },
    };
&lt;/script&gt;
</code></pre></template></demo-block>
      </section>
    </template>
    <script>
        null
      export default {
        name: 'component-doc',
        components: {
          "element-demo0": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('div',[_vm._v("\n        打开F12 查看 console 信息\n        "),_c('ve-table',{attrs:{"border-y":"","fixed-header":"","max-height":300,"columns":_vm.columns,"table-data":_vm.tableData,"footer-data":_vm.footerData,"rowKeyFieldName":"rowKey","event-custom-option":_vm.eventCustomOption}})],1)]],2)}
var staticRenderFns = []

  
    const democomponentExport = {
        data() {
            return {
                eventCustomOption: {
                    footerRowEvents: ({ row, rowIndex }) => {
                        return {
                            click: (event) => {
                                console.log("click::", row, rowIndex, event);
                            },
                            dblclick: (event) => {
                                console.log("dblclick::", row, rowIndex, event);
                            },
                            contextmenu: (event) => {
                                console.log("contextmenu::", row, rowIndex, event);
                            },
                            mouseenter: (event) => {
                                console.log("mouseenter::", row, rowIndex, event);
                            },
                            mouseleave: (event) => {
                                console.log("mouseleave::", row, rowIndex, event);
                            },
                        };
                    },
                },
                columns: [
                    {
                        field: "",
                        key: "a",
                        title: "",
                        width: 50,
                        align: "center",
                        renderBodyCell: ({ row, column, rowIndex }, h) => {
                            return ++rowIndex;
                        },
                    },
                    {
                        field: "name",
                        key: "b",
                        title: "Name",
                        width: 200,
                        align: "left",
                    },
                    {
                        field: "hobby",
                        key: "c",
                        title: "Hobby",
                        width: 300,
                        align: "left",
                    },
                    {
                        field: "address",
                        key: "d",
                        title: "Address",
                        width: "",
                        align: "left",
                    },
                ],
                tableData: [],
            };
        },
        methods: {
            initTableData() {
                let data = [];
                for (let i = 0; i < 15; i++) {
                    data.push({
                        rowKey: i,
                        name: i,
                        date: i,
                        hobby: i,
                        address: i,
                    });
                }
                this.tableData = data;
            },

            initFooterData() {
                this.footerData = [
                    {
                        rowKey: 0,
                        name: "平均值",
                        date: 213,
                        hobby: 355,
                        address: 189,
                    },
                    {
                        rowKey: 1,
                        name: "汇总值",
                        date: 1780,
                        hobby: 890,
                        address: 2988,
                    },
                ];
            },
        },
        created() {
            this.initTableData();
            this.initFooterData();
        },
    };
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),
        }
      }
    </script>
    <style lang="less">
      
    </style>
  